import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './plugins/i18n.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'cookieconsent/build/cookieconsent';

createApp(App)
  .use(router)
  .use(store)
  .use(i18n)
  .mount('#app')
;
